var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { transition, isArray } from "@studiometa/js-toolkit/utils";
function delegateTransition(elementOrElements, name, endMode) {
  return isArray(elementOrElements) || elementOrElements instanceof NodeList ? Promise.all(
    Array.from(elementOrElements).map((el) => transition(el, name, endMode))
  ) : transition(elementOrElements, name, endMode);
}
function withTransition(BaseClass) {
  class Transition extends BaseClass {
    get target() {
      return this.$el;
    }
    async enter(target) {
      const { enterFrom, enterActive, enterTo, enterKeep, leaveTo } = this.$options;
      await delegateTransition(
        target != null ? target : this.target,
        {
          from: (leaveTo + " " + enterFrom).trim(),
          active: enterActive,
          to: enterTo
        },
        enterKeep && "keep"
      );
    }
    async leave(target) {
      const { leaveFrom, leaveActive, leaveTo, leaveKeep, enterTo } = this.$options;
      await delegateTransition(
        target != null ? target : this.target,
        {
          from: (enterTo + " " + leaveFrom).trim(),
          active: leaveActive,
          to: leaveTo
        },
        leaveKeep && "keep"
      );
    }
  }
  __publicField(Transition, "config", {
    name: "Transition",
    options: {
      enterFrom: String,
      enterActive: String,
      enterTo: String,
      enterKeep: Boolean,
      leaveFrom: String,
      leaveActive: String,
      leaveTo: String,
      leaveKeep: Boolean
    }
  });
  return Transition;
}
export {
  withTransition
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
